import { authedJson } from '../api/client';

export type ScheduleType = 'BUSINESS_DAYS' | 'ALL_DAYS' | 'BUSINESS_DAYS_NO_HOLIDAYS';

export interface WorkspaceSettings {
  workspaceId: string;
  pointsPerDay: number;
  scheduleType: ScheduleType;
  updatedAt: number;
}

export interface UpdateWorkspaceSettingsRequest {
  pointsPerDay?: number;
  scheduleType?: ScheduleType;
}

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

export const settingsApi = {
  get: (workspaceId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<WorkspaceSettings>(`/workspaces/${workspaceId}/settings`, { method: 'GET' }, getToken, doRefresh),

  update: (workspaceId: string, updates: UpdateWorkspaceSettingsRequest, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<WorkspaceSettings>(
      `/workspaces/${workspaceId}/settings`,
      { method: 'PUT', body: JSON.stringify(updates) },
      getToken,
      doRefresh,
    ),
};
